export default __webpack_public_path__ + "static/media/ic_arrow.d04a2762.svg";